import { Component } from 'react';
import Grid from '@mui/material/Grid';
import LinearProgress from '@mui/material/LinearProgress';
import List from '@mui/material/List';
import Paper from '@mui/material/Paper';
import MapsScheduleCollection from './maps/MapsScheduleCollection';
import ScheduleFilter from './common/ScheduleFilter';
import { LocalAtRecord } from '../../db';
import { SettingsAccessLevel } from '../../types/types';

interface MapsScheduleViewProps {
  loadingSchedule: boolean;
  loadMissionMaps: (id: string) => Promise<void>;
  loadSchedule: (forceRefresh: boolean) => Promise<void>;
  scheduleItems: LocalAtRecord[];
  accessLevel: SettingsAccessLevel;
}

interface MapsScheduleViewState {
  filterText: string;
}

export default class MapsScheduleView extends Component<MapsScheduleViewProps, MapsScheduleViewState> {
  constructor(props: MapsScheduleViewProps) {
    super(props);
    this.state = {
      filterText: '',
    };

    this.updateFilter = this.updateFilter.bind(this);
  }

  updateFilter(filterText: string) {
    this.setState({ filterText });
  }

  render() {
    return (
      <Paper style={{ width: '100%', marginTop: 10 }}>
        <Grid container spacing={1} size={12}>
          <ScheduleFilter
            updateFilter={this.updateFilter}
            loadSchedule={this.props.loadSchedule}
            filterText={this.state.filterText}
          />

          <Grid size={12}>
            <Paper elevation={3} style={{ padding: 5, margin: 10 }}>
              {/* missions loading */}
              {this.props.loadingSchedule ? (
                <LinearProgress color="secondary" style={{ margin: 20 }} />
              ) : this.props.scheduleItems.length === 0 ? (
                <List dense>No missions found.</List>
              ) : (
                <MapsScheduleCollection
                  items={this.props.scheduleItems}
                  filterText={this.state.filterText}
                  loadMissionMaps={this.props.loadMissionMaps}
                  accessLevel={this.props.accessLevel}
                />
              )}
            </Paper>
          </Grid>
        </Grid>
      </Paper>
    );
  }
}
